/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
// import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordNotificationDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_lead_notification`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export async function createNotificationRecord(submitValue) {
  console.log("aaa........", submitValue)
  // let payload ={submitValue}


  return api
    .post(`/add_lead_notification`, submitValue)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))

}
// {

//   console.log("inside api call------------", notificationList)
//   try {
//     const response = await api.post(
//       `/add_lead_${atob(constantName)}_event`,
//       record,
//       //quotationData
//       notificationList
//     )
//     console.log(response.data, "response data from api call")
//     //return response.data
//     return Promise.resolve(response.data)
//   } catch (error) {
//     return Promise.reject(error)
//   }
// }

export async function updateNotificationRecord(updateNotificationData) {
  // try {
  //   console.log("Updated Api data ---> ")

  //   const response = await api.post(
  //     `/update_lead_${atob(constantName)}_event`,
  //    // quotationData
  //    notificationList
  //   )
  //   console.log(response.data, "response updated data")
  //   return Promise.resolve(response.data)
  // } catch (error) {
  //   return Promise.reject(error)
  // }


  console.log("UPDATE........", updateNotificationData)

  return api
    .post(`/update_lead_notification`, updateNotificationData)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))


}



/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteNotificationRecord(deleteNotificationData) {
  // const quotationLeadId = id
  // const payload = {
  //   leadId: quotationLeadId,
  //   leadQuotationEventId: quotationRemoveId,
  // }

  console.log("DELETE........", deleteNotificationData)
  return api
    .post(`/delete_lead_notification`, deleteNotificationData)
    .catch((error) => Promise.reject(error))
}

//updatecheckbox api

export function updateCheckboxApi (checkboxData) {
  return api
    .post(`/update_lead_notification_checkbox`, checkboxData)
    .catch((error) => Promise.reject(error))
}



const remotes = {
  loadRecordsMetaData,
  loadRecordNotificationDetails,
  createNotificationRecord,
  updateNotificationRecord,
  deleteNotificationRecord,
  updateCheckboxApi,
}

export default remotes
